<script lang="ts">
	// Formatting
	import { format } from 'svelte-i18n';
	// Stores
	import { selectraIsQualified, selectraLoading, selectraPrices } from 'src/stores/selectra';
	// Components
	import SelectraPlanCard from './SelectraPlanCard.svelte';
	import SelectraTariffChart from './SelectraTariffChart.svelte';
	// Design system components
	import { Alert, Loader, Text } from '@Shelly/shelly-design-system';
</script>

<Text styleType="body-small" class="text-bold mb-s">
	{$format('label_selectra_live_tariff_mode', {
		default: 'Your live tariff is automatically updated from your dynamic energy plan.',
	})}
</Text>

{#if $selectraLoading && !$selectraPrices}
	<div class="d-flex justify-content-center p-m">
		<Loader size="m" />
	</div>
{:else}
	<SelectraPlanCard />

	{#if $selectraPrices?.requalification_reason}
		<Alert
			class="mt-s mb-s"
			type="warning"
			heading={$format('label_selectra_requalification_needed', {
				default: 'Your plan needs to be reconfigured',
			})}
			message={$selectraPrices.requalification_reason}
		/>
	{/if}

	{#if $selectraIsQualified}
		<div class="mt-m">
			<SelectraTariffChart />
		</div>
	{/if}
{/if}
